<template>
    <div>
        <HeaderBg title="تعرف علينا" />

        <div class="form_container">
            <form @submit.prevent="addAboutUs">
                <h2 class="sections-title"> الهيدر </h2>
                <div class="upload_img">
                    <span> الصورة الرئيسية باللغة العربية (267 × 140 px) </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="headerImgUrl == ''">
                        <img :src="headerImgUrl" alt="" v-if="headerImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadHeaderImg] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="upload_img">
                    <span> الصورة الرئيسية باللغة الإنجليزية (267 × 140 px) </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="headerImgUrlEn == ''">
                        <img :src="headerImgUrlEn" alt="" v-if="headerImgUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadHeaderImgEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <h2 class="sections-title"> القسم الأول </h2>
                <div class="upload_img">
                    <span> صورة عن المجموعة باللغة العربية (572 × 624 px) </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="aboutTheGroupImgUrl == ''">
                        <img :src="aboutTheGroupImgUrl" alt="" v-if="aboutTheGroupImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadAboutTheGroupImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="upload_img">
                    <span> صورة عن المجموعة باللغة الإنجليزية (572 × 624 px) </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="aboutTheGroupImgUrlEn == ''">
                        <img :src="aboutTheGroupImgUrlEn" alt="" v-if="aboutTheGroupImgUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadAboutTheGroupImgUrlEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label> عنوان عن المجموعة باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].title">
                </div>
                <div class="input_container">
                    <label>  عنوان عن المجموعة باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].title">
                </div>

                <div class="input_container">
                    <label>  وصف عن المجموعة باللغة العربية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[0].content" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>  وصف عن المجموعة باللغة الإنجليزية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[1].content" />
                    </client-only>
                </div>

                <hr>
                <!-- second section -->
                 <h2 class="sections-title"> القسم الثاني </h2>
                <div class="input_container">
                    <label>  عنوان تعرف علينا باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].second_section_title">
                </div>
                <div class="input_container">
                    <label>  عنوان تعرف علينا باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].second_section_title">
                </div>
                <div class="upload_img">
                    <span> صورة تعرف علينا 1 </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="aboutUsImgUrlOne == ''">
                        <img :src="aboutUsImgUrlOne" alt="" v-if="aboutUsImgUrlOne !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadAboutUsImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>  عنوان اول باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].second_section_sub_title_1">
                </div>
                <div class="input_container">
                    <label>  عنوان اول باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].second_section_sub_title_1">
                </div>
                <div class="input_container">
                    <label>  وصف العنوان الاول باللغة العربية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[0].second_section_sub_title_1_desc" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>  وصف العنوان الاول باللغة الإنجليزية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[1].second_section_sub_title_1_desc" />
                    </client-only>
                </div>
                <div class="upload_img">
                    <span> صورة تعرف علينا 2 </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="aboutUsImgUrlTwo == ''">
                        <img :src="aboutUsImgUrlTwo" alt="" v-if="aboutUsImgUrlTwo !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadAboutUsImgUrlTwo] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>  عنوان ثاني باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].second_section_sub_title_2">
                </div>
                <div class="input_container">
                    <label>  عنوان ثاني باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].second_section_sub_title_2">
                </div>
                <div class="input_container">
                    <label>  وصف العنوان الثاني باللغة العربية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[0].second_section_sub_title_2_desc" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>  وصف العنوان الثاني باللغة الإنجليزية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[1].second_section_sub_title_2_desc" />
                    </client-only>
                </div>

                <hr>
                <h2 class="sections-title"> القسم الثالث </h2>
                <!-- third section -->
                 <div class="upload_img">
                    <span> صورة الهيكل التنظيمي باللغة العربية (1272 × 529 px) </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="third_section_sub_title_1_imageUrl == ''">
                        <img :src="third_section_sub_title_1_imageUrl" alt="" v-if="third_section_sub_title_1_imageUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadThird_section_sub_title_1_imageUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="upload_img">
                    <span> صورة الهيكل التنظيمي باللغة الإنجليزية (1272 × 529 px) </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="third_section_sub_title_1_imageUrlEn == ''">
                        <img :src="third_section_sub_title_1_imageUrlEn" alt="" v-if="third_section_sub_title_1_imageUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadThird_section_sub_title_1_imageUrlEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input_container">
                    <label>  عنوان اول باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].third_section_title">
                </div>
                <div class="input_container">
                    <label>  عنوان اول باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].third_section_title">
                </div>
                <div class="input_container">
                    <label>  عنوان ثاني باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].third_section_sub_title_1">
                </div>
                <div class="input_container">
                    <label>  عنوان ثاني باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].third_section_sub_title_1">
                </div>

                <hr>
                <h2 class="sections-title"> القسم الرابع </h2>

                <!-- fourth section -->
                <div class="upload_img">
                    <span> صورة خدماتنا 1 </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="fourth_section_sub_title_1_imageUrl == ''">
                        <img :src="fourth_section_sub_title_1_imageUrl" alt="" v-if="fourth_section_sub_title_1_imageUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadfourth_section_sub_title_1_imageUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input_container">
                    <label>  عنوان خدماتنا باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fourth_section_title">
                </div>
                <div class="input_container">
                    <label>  عنوان خدماتنا باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fourth_section_title">
                </div>

                <div class="input_container">
                    <label>  عنوان اول باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fourth_section_sub_title_1">
                </div>
                <div class="input_container">
                    <label>  عنوان اول باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fourth_section_sub_title_1">
                </div>
                <div class="input_container">
                    <label>  وصف اول باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fourth_section_sub_title_1_desc">
                </div>
                <div class="input_container">
                    <label>  وصف اول باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fourth_section_sub_title_1_desc">
                </div>

                <div class="upload_img">
                    <span> صورة خدماتنا 2 </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="fourth_section_sub_title_2_imageUrl == ''">
                        <img :src="fourth_section_sub_title_2_imageUrl" alt="" v-if="fourth_section_sub_title_2_imageUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadfourth_section_sub_title_2_imageUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>  عنوان ثاني باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fourth_section_sub_title_2">
                </div>
                <div class="input_container">
                    <label>  عنوان ثاني باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fourth_section_sub_title_2">
                </div>
                <div class="input_container">
                    <label>  وصف ثاني باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fourth_section_sub_title_2_desc">
                </div>
                <div class="input_container">
                    <label>  وصف ثاني باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fourth_section_sub_title_2_desc">
                </div>
                <div class="upload_img">
                    <span> صورة خدماتنا 3 </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="fourth_section_sub_title_3_imageUrl == ''">
                        <img :src="fourth_section_sub_title_3_imageUrl" alt="" v-if="fourth_section_sub_title_3_imageUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadfourth_section_sub_title_3_imageUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>  عنوان ثالث باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fourth_section_sub_title_3">
                </div>
                <div class="input_container">
                    <label>  عنوان ثالث باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fourth_section_sub_title_3">
                </div>
                <div class="input_container">
                    <label>  وصف ثالث باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fourth_section_sub_title_3_desc">
                </div>
                <div class="input_container">
                    <label>  وصف ثالث باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fourth_section_sub_title_3_desc">
                </div>

                <div class="upload_img">
                    <span> صورة خدماتنا 4 </span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="fourth_section_sub_title_4_imageUrl == ''">
                        <img :src="fourth_section_sub_title_4_imageUrl" alt="" v-if="fourth_section_sub_title_4_imageUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadfourth_section_sub_title_4_imageUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>  عنوان رابع باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fourth_section_sub_title_4">
                </div>
                <div class="input_container">
                    <label>  عنوان رابع باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fourth_section_sub_title_4">
                </div>
                <div class="input_container">
                    <label>  وصف رابع باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fourth_section_sub_title_4_desc">
                </div>
                <div class="input_container">
                    <label>  وصف رابع باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fourth_section_sub_title_4_desc">
                </div>

                <!-- section 5 -->
                 <hr>
                <h2 class="sections-title"> القسم الخامس </h2>
                <div class="input_container">
                    <label>  عنوان المشاركات المجتمعية باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fifth_section_title">
                </div>
                <div class="input_container">
                    <label>  عنوان المشاركات المجتمعية باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fifth_section_title">
                </div>
                <div class="input_container">
                    <label>  عنوان اول باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].fifth_section_sub_title_1">
                </div>
                <div class="input_container">
                    <label>  عنوان اول باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].fifth_section_sub_title_1">
                </div>
                <div class="input_container">
                    <label>  وصف باللغة العربية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[0].fifth_section_sub_title_1_desc" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>  وصف باللغة الإنجليزية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[1].fifth_section_sub_title_1_desc" />
                    </client-only>
                </div>

                <!-- section 6 -->
                <hr>
                <h2 class="sections-title"> القسم السادس </h2>
                <div class="input_container">
                    <label>  عنوان اول باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].Sixth_section_sub_title_1">
                </div>
                <div class="input_container">
                    <label>  عنوان اول باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].Sixth_section_sub_title_1">
                </div>

                <div class="input_container">
                    <label>  وصف اول باللغة العربية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[0].sixth_sectionSixth_section_sub_title_1_desc_title" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>  وصف اول باللغة الإنجليزية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[1].sixth_sectionSixth_section_sub_title_1_desc_title" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>  عنوان ثاني باللغة العربية </label>
                    <input type="text" v-model="aboutUs.translations[0].Sixth_section_sub_title_2">
                </div>
                <div class="input_container">
                    <label>  عنوان ثاني باللغة الإنجليزية </label>
                    <input type="text" v-model="aboutUs.translations[1].Sixth_section_sub_title_2">
                </div>
                <div class="input_container">
                    <label>  وصف ثاني باللغة العربية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[0].Sixth_section_sub_title_2_desc" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>  وصف ثاني باللغة الإنجليزية </label>
                    <client-only>
                        <VueEditor  v-model="aboutUs.translations[1].Sixth_section_sub_title_2_desc" />
                    </client-only>
                </div>
                <div class="alert alert-success mt-2" role="alert" v-if="successMessage">
                    تم التعديل بنجاح
                </div>
                <div class="alert alert-danger mt-2" role="alert" v-if="ErrorCheck == true">
                    <p v-for="(error, index) in errors" :key="index"> {{error}} </p>
                </div>
                <button class="saveBtn" v-if="postLoaded == false">
                    حفظ +
                </button>
                <button class="saveBtn" v-if="postLoaded == true"><b-spinner></b-spinner></button>
            </form>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import Request from '../../../services/Request';
import { VueEditor } from "vue2-editor";
export default {
    name :'AboutUsPageData',
    components: {HeaderBg, VueEditor},
    data(){
        return{
            postLoaded: false,
            successMessage: false,
            headerImgUrl: '',
            headerImgUrlEn: '',
            aboutTheGroupImgUrl: '',
            aboutTheGroupImgUrlEn: '',
            aboutUsImgUrlOne: '',
            aboutUsImgUrlTwo: '',
            third_section_sub_title_1_imageUrl: '',
            third_section_sub_title_1_imageUrlEn: '',

            // fourth section
            fourth_section_sub_title_1_imageUrl: '',
            fourth_section_sub_title_2_imageUrl: '',
            fourth_section_sub_title_3_imageUrl: '',
            fourth_section_sub_title_4_imageUrl: '',
            aboutUs: {
                logo : '',
                logo_en : '',
                first_image : '',
                first_image_en : '',
                uploadAboutUsImgUrl : '',
                second_section_sub_title_1_image : '',
                second_section_sub_title_1_desc_image : '',
                third_section_sub_title_1_image : '',
                third_section_sub_title_1_image_en : '',

                // fourth section
                fourth_section_sub_title_1_image: '',
                fourth_section_sub_title_2_image: '',
                fourth_section_sub_title_3_image: '',
                fourth_section_sub_title_4_image: '',
                translations : [
                    {
                        title : "",
                        content : "",

                        // section 2
                        second_section_title : "",
                        second_section_sub_title_1 : "",
                        second_section_sub_title_1_desc : "",
                        second_section_sub_title_2 : "",
                        second_section_sub_title_2_desc : "",

                        // section 3
                        third_section_title : "",
                        third_section_sub_title_1 : "",

                        // section 4
                        fourth_section_title : "",
                        fourth_section_sub_title_1 : "",
                        fourth_section_sub_title_1_desc : "",
                        fourth_section_sub_title_2 : "",
                        fourth_section_sub_title_2_desc : "",
                        fourth_section_sub_title_3 : "",
                        fourth_section_sub_title_3_desc : "",
                        fourth_section_sub_title_4 : "",
                        fourth_section_sub_title_4_desc : "",

                        // section 5
                        fifth_section_title : "",
                        fifth_section_sub_title_1 : "",
                        fifth_section_sub_title_1_desc : "",

                        // section 6
                        sixth_section_title : "",
                        Sixth_section_sub_title_1 : "",
                        sixth_sectionSixth_section_sub_title_1_desc_title : "",
                        Sixth_section_sub_title_2 : "",
                        Sixth_section_sub_title_2_desc : "",

                        locale : "ar"
                    },
                    {
                        title : "",
                        content : "",

                        // section 2
                        second_section_title : "",
                        second_section_sub_title_1 : "",
                        second_section_sub_title_1_desc : "",
                        second_section_sub_title_2 : "",
                        second_section_sub_title_2_desc : "",

                        // section 3
                        third_section_title : "",
                        third_section_sub_title_1 : "",

                        // section 4
                        fourth_section_title : "",
                        fourth_section_sub_title_1 : "",
                        fourth_section_sub_title_1_desc : "",
                        fourth_section_sub_title_2 : "",
                        fourth_section_sub_title_2_desc : "",
                        fourth_section_sub_title_3 : "",
                        fourth_section_sub_title_3_desc : "",
                        fourth_section_sub_title_4 : "",
                        fourth_section_sub_title_4_desc : "",

                        // section 5
                        fifth_section_title : "",
                        fifth_section_sub_title_1 : "",
                        fifth_section_sub_title_1_desc : "",

                        // section 6
                        sixth_section_title : "",
                        Sixth_section_sub_title_1 : "",
                        sixth_sectionSixth_section_sub_title_1_desc_title : "",
                        Sixth_section_sub_title_2 : "",
                        Sixth_section_sub_title_2_desc : "",

                        locale : "en"
                    }
                ]
            },
            errors: [],
            ErrorCheck: false,
        }
    },
    mounted(){
        this.getAboutUsPage();
    },
    methods:{
        addAboutUs() {
    this.successMessage = false;
    this.postLoaded = true;
    this.errors = [];
    this.ErrorCheck = false;

    const formData = new FormData();

    // ✅ append images
    if (this.aboutUs.logo) {
        formData.append("logo", this.aboutUs.logo);
    }
    if (this.aboutUs.logo_en) {
        formData.append("logo_en", this.aboutUs.logo_en);
    }
    if (this.aboutUs.first_image) {
        formData.append("first_image", this.aboutUs.first_image);
    }
    if (this.aboutUs.first_image_en) {
        formData.append("first_image_en", this.aboutUs.first_image_en);
    }
    if (this.aboutUs.second_section_sub_title_1_image) {
        formData.append("second_section_sub_title_1_image", this.aboutUs.second_section_sub_title_1_image);
    }
    if (this.aboutUs.second_section_sub_title_1_desc_image) {
        formData.append("second_section_sub_title_1_desc_image", this.aboutUs.second_section_sub_title_1_desc_image);
    }
    if (this.aboutUs.third_section_sub_title_1_image) {
        formData.append("third_section_sub_title_1_image", this.aboutUs.third_section_sub_title_1_image);
    }
    if (this.aboutUs.third_section_sub_title_1_image_en) {
        formData.append("third_section_sub_title_1_image_en", this.aboutUs.third_section_sub_title_1_image_en);
    }

    // ✅ append 4th section images
    if (this.aboutUs.fourth_section_sub_title_1_image) {
        formData.append("fourth_section_sub_title_1_image", this.aboutUs.fourth_section_sub_title_1_image);
    }
    if (this.aboutUs.fourth_section_sub_title_2_image) {
        formData.append("fourth_section_sub_title_2_image", this.aboutUs.fourth_section_sub_title_2_image);
    }
    if (this.aboutUs.fourth_section_sub_title_3_image) {
        formData.append("fourth_section_sub_title_3_image", this.aboutUs.fourth_section_sub_title_3_image);
    }
    if (this.aboutUs.fourth_section_sub_title_4_image) {
        formData.append("fourth_section_sub_title_4_image", this.aboutUs.fourth_section_sub_title_4_image);
    }

    // ✅ append translations (ar/en)
    this.aboutUs.translations.forEach((t, index) => {
        Object.keys(t).forEach(key => {
            formData.append(`translations[${index}][${key}]`, t[key]);
        });
    });

    axios.post("https://app.almujtama.com.sa/admin/about_us_page", formData, {
        headers: { 
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data"
        }
    })
    .then(() => {
        this.postLoaded = false;
        this.ErrorCheck = false;
        this.successMessage = true;
    })
    .catch(err => {
        if (err.response && err.response.data && err.response.data.errors) {
            this.errors = err.response.data.errors;
            this.ErrorCheck = true;
        }
        this.postLoaded = false;
    });
},

        uploadHeaderImg(e) {
            this.aboutUs.logo = e.target.files[0];
            this.headerImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadHeaderImgEn(e) {
            this.aboutUs.logo_en = e.target.files[0];
            this.headerImgUrlEn = URL.createObjectURL(e.target.files[0]);
        },
        uploadAboutTheGroupImgUrl(e) {
            this.aboutUs.first_image = e.target.files[0];
            this.aboutTheGroupImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadAboutTheGroupImgUrlEn(e) {
            this.aboutUs.first_image_en = e.target.files[0];
            this.aboutTheGroupImgUrlEn = URL.createObjectURL(e.target.files[0]);
        },
        uploadAboutUsImgUrl(e) {
            this.aboutUs.second_section_sub_title_1_image = e.target.files[0];
            this.aboutUsImgUrlOne = URL.createObjectURL(e.target.files[0]);
        },
        uploadAboutUsImgUrlTwo(e) {
            this.aboutUs.second_section_sub_title_1_desc_image = e.target.files[0];
            this.aboutUsImgUrlTwo = URL.createObjectURL(e.target.files[0]);
        },
        uploadThird_section_sub_title_1_imageUrl(e) {
            this.aboutUs.third_section_sub_title_1_image = e.target.files[0];
            this.third_section_sub_title_1_imageUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadThird_section_sub_title_1_imageUrlEn(e) {
            this.aboutUs.third_section_sub_title_1_image_en = e.target.files[0];
            this.third_section_sub_title_1_imageUrlEn = URL.createObjectURL(e.target.files[0]);
        },
        uploadfourth_section_sub_title_1_imageUrl(e) {
            this.aboutUs.fourth_section_sub_title_1_image = e.target.files[0];
            this.fourth_section_sub_title_1_imageUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadfourth_section_sub_title_2_imageUrl(e) {
            this.aboutUs.fourth_section_sub_title_2_image = e.target.files[0];
            this.fourth_section_sub_title_2_imageUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadfourth_section_sub_title_3_imageUrl(e) {
            this.aboutUs.fourth_section_sub_title_3_image = e.target.files[0];
            this.fourth_section_sub_title_3_imageUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadfourth_section_sub_title_4_imageUrl(e) {
            this.aboutUs.fourth_section_sub_title_4_image = e.target.files[0];
            this.fourth_section_sub_title_4_imageUrl = URL.createObjectURL(e.target.files[0]);
        },
        
        getAboutUsPage(){
            Request.fetch(`admin/about_us_page/show`, '')
            .then((response) => {
                console.log(response, 'about')
                this.headerImgUrl= response.data.data.logo,
                this.headerImgUrlEn= response.data.data.logo_en,
                this.aboutTheGroupImgUrl= response.data.data.first_image,
                this.aboutTheGroupImgUrlEn= response.data.data.first_image_en,
                this.aboutUsImgUrlOne= response.data.data.second_section_sub_title_1_image,
                this.aboutUsImgUrlTwo= response.data.data.second_section_sub_title_1_desc_image,
                this.third_section_sub_title_1_imageUrl= response.data.data.third_section_sub_title_1_image,
                this.third_section_sub_title_1_imageUrlEn= response.data.data.third_section_sub_title_1_image_en,
                // fourth section
                this.fourth_section_sub_title_1_imageUrl= response.data.data.fourth_section_sub_title_1_image,
                this.fourth_section_sub_title_2_imageUrl= response.data.data.fourth_section_sub_title_2_image,
                this.fourth_section_sub_title_3_imageUrl= response.data.data.fourth_section_sub_title_3_image,
                this.fourth_section_sub_title_4_imageUrl= response.data.data.fourth_section_sub_title_4_image,

                this.aboutUs.translations = response.data.data.translations;

            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.form_container{
    background-color: #FFF;
    border-radius: 10px;
    margin: 40px auto;
    padding: 70px 100px;
    @media (max-width: 576px) {
        width: 97%;
        padding: 30px;
    }
    form{
        > div{
            margin-bottom: 40px;
            label{
                display: block;
                text-align: center;
                font-size: 16px;
                color: #717171;
                font-weight: 600;
                margin-bottom: 10px;
            }
            input{
                border: 1px solid #71717191;
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 10px;
                display: block;
                margin: auto;
                width: 50%;
            }
        }
        button{
            margin: 30px auto 0 auto;   
        }
    }
}
.upload_img{
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            width: 100%;
            span{
                font-size: 16px;
                color: #656565;
                margin-inline-end: 50px;
            }
            .img_container{
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background-color: #FAFAFA;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                img{
                    width: 100%;
                }
                .photo_upload{
                    
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    img{
                        width: 70%;
                    }
                }
            }
        }
</style>